var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn text-uppercase btn-sm btn-info btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }